/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalVisualizationAPI
 * @hideconstructor
 */
define([], () => {
	class InternalVisualizationAPI {

		/**
		 * @description Get the list of search filters
		 * @function InternalVisualizationAPI#getSearchFilterList
		 * @public
		 * @return list of search filters
		 */
		getSearchFilterList() {}

		/**
		 * @description Get isPreview flag to indicate if the widget is preview widget.
		 * @function InternalVisualizationAPI#isPreview
		 *
		 * @return true if the widget is a preview widget.
		 */
		isPreview() {}

		/**
		 * @description Determine whether the visualization is a predict preview
		 * @function InternalVisualizationAPI#isPredictPreview
		 * @return true if the widget is a predict preview visualization, otherwise false.
		 */
		isPredictPreview() {}

		/**
		 * @description Validate the local filter to ensure all filters are referring to an existing valid column
		 * @function validateLocalFilters#validateLocalFilters
		 */
		validateLocalFilters() {}
	}

	return InternalVisualizationAPI;
});
